<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showUploadExcelTecnica"
      scrollable
      no-close-on-backdrop
      title="Cargar excel"
      cancel-variant="outline-secondary"
      @hidden="resetModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-file
            v-model="file"
            placeholder="Selecciona o arrastra un archivo Excel"
            drop-placeholder="Arrastra un archivo excel"
          />
        </b-col>
      </b-row>
      <div
        :id="`pop_info_equipos`"
        style="width:100%; margin-top:15px;padding:10px; text-align:center; text-decoration:underline"
      >
        Nombres de equipos permitidos
      </div>
      <b-popover
        ref="popover"
        :target="`pop_info_equipos`"
        triggers="hover"
        :show.sync="popoverShowIA"
        placement="auto"
        container="my-container"
      >
        <template v-slot:title>
          <div>
            <span>Nombres permitidos</span>
          </div>
        </template>
        <div style="max-height: 350px; overflow-y: auto;">
          <div v-for="item in listEquipos" :key="item.id_equipo">
            {{ item.equipo }}
          </div>
        </div>
      </b-popover>
      <!-- <div>
        <b-list-group>
          <b-list-group-item v-for="item in listEquipos" :key="item.id_equipo">
            <small class="notification-text">
              {{ item.equipo }}
            </small>
          </b-list-group-item>
        </b-list-group>
      </div> -->
      <b-alert v-if="showError" show variant="danger">
        <div class="alert-body">
          <feather-icon class="mr-25" icon="AlertTriangleIcon" />
          <span>{{ mensaje }}</span>
        </div>
      </b-alert>
      <!-- <b-row class="mt-1">
        <b-col>
          <b-alert show variant="danger">
            <div class="alert-body">
              <feather-icon class="mr-25" icon="AlertTriangleIcon" />
            </div>
          </b-alert>
          <b-alert show variant="danger">
            <div class="alert-body">
              <feather-icon class="mr-25" icon="AlertTriangleIcon" />
            </div>
          </b-alert>
          <b-list-group>
            <b-list-group-item v-for="item in 10" :key="item.id">
              <span class="font-weight-bolder"
                >{{ item.cedula }} {{ item.apellidos }}
                {{ item.nombres }} </span
              ><br />
              <small class="notification-text">
                {{ item.mensaje }}
              </small>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row> -->

      <template #modal-footer>
        <div class="w-100">
          <template v-if="!showLoading">
            <b-button
              v-if="file != null"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="primary"
              size="sm"
              class="float-right"
              @click="uploadExcel"
            >
              <feather-icon icon="UploadCloudIcon" class="mr-50" />
              <span class="align-middle">Subir</span>
            </b-button>
          </template>
          <div v-if="showLoading" class="text-center mt-1">
            <b-spinner variant="primary" label="Text Centered" />
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import {
  BRow,
  BCol,
  BFormFile,
  //   BCardText,
  BButton,
  BAlert,
  // BListGroup,
  // BListGroupItem,
  BSpinner,
  VBPopover,
  BPopover,
  //  xxx
} from 'bootstrap-vue'
import store from '@/store'
import { URL, USER } from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BRow,
    BCol,
    BFormFile,
    // BCardText,
    BButton,
    BAlert,
    // BListGroup,
    // BListGroupItem,
    BSpinner,
    BPopover,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  props: {
    dataEquipo: Object,
    listEquipos: Array,
    etapa: Object,
    grupo: Object,
    categoriaSeleccionada: Object,
    campeonatoSeleccionado: Object,
  },
  setup(props, { emit }) {
    const file = ref(null)
    const listInconsistentes = ref([])
    const insertados = ref(null)
    const inconsitencias = ref(null)
    const errorMaximo = ref(null)
    const errorMessage = ref(null)
    const showLoading = ref(false)
    const popoverShowIA = ref(null)
    const mensaje = ref('')
    const showError = ref(false)

    const { postApiFormData } = apiCall()
    async function uploadExcel() {
      // console.log(props.categoriaSeleccionada)
      // console.log(props.etapa)
      // console.log(props.grupo)
      showLoading.value = true
      const archivo = new FormData()
      archivo.append('file', file.value)
      archivo.append('id_categoria', props.categoriaSeleccionada.value)
      archivo.append('etapa', props.etapa.value)
      archivo.append('grupo', props.grupo.grupo)
      archivo.append('id_modalidad_grupo', props.grupo.id_modalidad_grupo)
      archivo.append('id_campeonato', props.campeonatoSeleccionado.value)
      // archivo.append('id_equipo', props.dataEquipo.id_equipo)
      archivo.append('idUsuarioIngresa', USER().id_usuario)
      const path = 'ApiFixture/insertFixtureExel'
      const response = await postApiFormData(URL, path, archivo)
      if (response.flag !== 'si') {
        showError.value = true
        mensaje.value = response.mensaje
      } else {
        store.commit('someVariables/UPDATE_SHOW_UPLOAD_EXCEL_TECNICA', false)
        emit('recargaFixture', {
          numFechas: response.num_fechas,
          espejo: null,
        })
      }
      file.value = null
      showLoading.value = false
    }
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      // emit('recargar', props.dataEquipo.id_equipo)
      // console.log('hidden')
      listInconsistentes.value = []
      insertados.value = null
      inconsitencias.value = null
      errorMessage.value = null
      errorMaximo.value = null
      file.value = null
      showLoading.value = false
      // initPlayer()
      //       this.$emit('closeModal', false)
    }
    return {
      file,
      uploadExcel,
      listInconsistentes,
      insertados,
      inconsitencias,
      errorMaximo,
      errorMessage,
      resetModal,
      showLoading,
      popoverShowIA,
      showError,
      mensaje,
    }
  },
}
</script>
